import {
  SAVE_PAST_ORDER,
  SAVE_LAST_ORDER,
  CLEAR_LAST_ORDER,
} from "../actions/actionTypes";

const initialState = {
  pastOrders: [],
  lastOrder: null,
  partOrdersForReOrder: [],
};

export default (state = initialState, { type, payload }) => {
  let newPastOrders = [];
  switch (type) {
    case SAVE_PAST_ORDER:
      newPastOrders = state.pastOrders.concat(payload);
      return { ...state, pastOrders: newPastOrders };
    case SAVE_LAST_ORDER:
      return { ...state, lastOrder: payload };
    case CLEAR_LAST_ORDER:
      return { ...state, lastOrder: null };
    case "ADD_TO_PAST_ORDERS":
      newPastOrders = [...state.pastOrders, payload].sort((a, b) => b - a);
      return { ...state, pastOrders: newPastOrders };
    case "ADD_TO_PAST_ORDERS_FROM_PROFILE": {
      let newPastOrders = [...state.pastOrders];
      payload.forEach((order) => {
        if (!state.pastOrders.includes(order)) {
          newPastOrders.push(order);
        }
      });
      return { ...state, pastOrders: newPastOrders.sort((a, b) => a - b) };
    }
    case "REMOVE_USER_PAST_ORDER": {
      const newPastOrders = state.pastOrders.filter(
        (order) => !payload.includes(order)
      );
      return { ...state, pastOrders: newPastOrders };
    }
    case "FETCH_TO_PAST_ORDERS_FOR_REORDER":
      return { ...state, partOrdersForReOrder: payload };

    case "FETCH_TO_PAST_ORDERS_FOR_REORDER_B2B":
      return { ...state, partOrdersForReOrder: payload, pastOrders:payload };
    default:
      return state;
  }
};
